const PREFIX = 'moata-home-' as const;

export const LocalStorageKey = {
  FeatureFlagEntryVisible: `${PREFIX}feature-flag-entry-visible`,
  FeatureFlagSettings: `${PREFIX}feature-flag-settings`,
} as const;

export const SessionStorageKey = {
  //
} as const;
